import jApi from './jApi';

export default {
  getListLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/list', req)
      .then(res => res);
  },
  getListParent(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/list', req)
      .then(res => res.data);
  },
  getDetailLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/detail', req)
      .then(res => res.data);
  },
  createLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/create', req)
      .then(res => res.data);
  },
  updateLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/update', req)
      .then(res => res.data);
  },
  deleteLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/delete', req)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiLayer.js